import React from 'react';
import type { IconPrefix, IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Skeleton } from '@progress/kendo-react-indicators';
import { Card } from '@progress/kendo-react-layout';
import cn from 'clsx';
import styles from '@components-clean/core/widgets/style.module.scss';

type IconTuple = [IconPrefix, IconName];

type RamWidgetItemProps = {
    title: string;
    value: string | number | null;
    icon: IconTuple;
    'data-testid'?: string;
};

const RamWidgetItem: React.FC<RamWidgetItemProps> = ({ title, value, icon, 'data-testid': testId }) => {
    const displayValue = value ?? 0;

    return (
        <Card
            className={cn('widget k-border k-border-solid k-border-transparent', styles.widgetCardStyling)}
            data-testid={testId}
        >
            <div className={cn('k-d-flex k-align-content-center', styles.cardHeaderStyling)}>
                <div className={styles.cardTitleStyling}>
                    <div className={styles.cardTitleTextStyling} title={String(title)}>
                        {title}
                    </div>
                </div>
            </div>

            <div className={cn('k-display-flex k-justify-content-start', styles.cardBody)}>
                <div className={styles.widgetIconContainer}>
                    <div className={styles.widgetContainer}>
                        <FontAwesomeIcon
                            icon={icon}
                            className={styles.frontIcon}
                            style={{ width: '37px', height: '32px' }}
                        />
                    </div>
                </div>
                <div className={styles.subtitleStyling}>{displayValue}</div>
            </div>
        </Card>
    );
};

export const RamWidgetSkeleton: React.FC = () => {
    return (
        <Card className={cn('widget k-border k-border-solid k-border-transparent', styles.widgetCardStyling)}>
            <div className={cn('k-d-flex k-align-content-center', styles.cardHeaderStyling)}>
                <div className={styles.cardTitleStyling}>
                    <div className={styles.cardTitleTextStyling}>
                        <Skeleton shape="text" style={{ width: 150, height: 20 }} />
                    </div>
                </div>
            </div>
            <div className={cn('k-display-flex k-justify-content-start', styles.cardBody)}>
                <div className={styles.widgetIconContainer}>
                    <Skeleton shape="text" style={{ width: 24, height: 24 }} />
                </div>
                <div className={styles.subtitleStyling}>
                    <Skeleton shape="text" style={{ width: 60, height: 24 }} />
                </div>
            </div>
        </Card>
    );
};

export default RamWidgetItem;
